import $ from 'jquery';
import {favouriteRemove} from './favourites';

const updaterRegistry = [];
export const sessionKey = 'site-data';

export function registerUpdater (func) {
  /* Register an updater function which should run after fetching data. */
  updaterRegistry.push(func);
}

export function updateFavourites (favourites) {
  $('body')[favourites.count ? 'addClass' : 'removeClass']('state-favourites-has-items');
  $('body')[favourites.count ? 'removeClass' : 'addClass']('state-favourites-empty');
  $('.favourites-snippet').html(favourites.html_snippet || '');
  $('.favourites-item-count').text(favourites.count || '');

  // bind the remove form
  document.querySelectorAll('.favourites-snippet form.remove-favourite:not(.initialised)').forEach((form) => {
    favouriteRemove(form);
    form.classList.add('initialised');
  });
}

export function globalUpdate (data) {
  // set site state based on data

  $('body')[data.account ? 'addClass' : 'removeClass']('state-logged-in');
  $('body')[data.account ? 'removeClass' : 'addClass']('state-anon');

  if (data.account) {
    $('.account-name').html(`${data.account.first_name} ${data.account.last_name}`);
  }

  if (data.favourites) {
    updateFavourites(data.favourites);
  }

  updaterRegistry.forEach((func) => {
    func(data);
  });
}

export function fetchData () {
  // TODO should just update based on the session data if it's there, but will
  // need to make sure it gets updated whenever globalUpdate is called - note
  // the data passed to globalUpdate may be incomplete, so the update needs to
  // be granular

  // for now, just run two updates - one on the session data and then another
  // once fresh data has been fetched

  const sessionData = JSON.parse(window.sessionStorage.getItem(sessionKey));

  function doUpdate (data) {
    globalUpdate(data);
    $('body').addClass('state-data-loaded');
  }

  if (sessionData) {
    doUpdate(sessionData);
  }
  $.get(window.URLS.get_data, function (data) {
    window.sessionStorage.setItem(sessionKey, JSON.stringify(data));
    doUpdate(data);
  });
}



// WEBPACK FOOTER //
// ./assets/j/shoptools/index.js